import React from 'react';
import BaseChart from './BaseChart';
import { EChartsOption } from 'echarts';

interface BarChartProps {
  data: {
    name: string;
    value: number;
  }[];
  title?: string;
  className?: string;
  loading?: boolean;
  orientation?: 'vertical' | 'horizontal';
}

const BarChart: React.FC<BarChartProps> = ({
  data,
  title,
  className,
  loading = false,
  orientation = 'vertical'
}) => {
  const option: EChartsOption = {
    title: {
      text: title,
      textStyle: {
        color: '#1f2937',
        fontSize: 16
      }
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      textStyle: {
        color: '#1f2937'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: orientation === 'vertical' ? {
      type: 'category',
      data: data.map(item => item.name),
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280'
      }
    } : {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280'
      }
    },
    yAxis: orientation === 'vertical' ? {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280'
      },
      splitLine: {
        lineStyle: {
          color: '#e5e7eb'
        }
      }
    } : {
      type: 'category',
      data: data.map(item => item.name),
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280'
      },
      splitLine: {
        lineStyle: {
          color: '#e5e7eb'
        }
      }
    },
    series: [
      {
        type: 'bar',
        data: data.map(item => ({
          name: item.name,
          value: item.value,
          itemStyle: {
            color: '#3B82F6'
          }
        })),
        barWidth: '60%'
      }
    ]
  };

  return (
    <BaseChart
      option={option}
      className={className}
      loading={loading}
    />
  );
};

export default BarChart;